import * as yup from 'yup';

export interface FormValues {
  email: string;
  mobilePhoneNumber: string;
  is2FAEnabled: boolean;
}

export const Validation = yup.object().shape({
  is2FAEnabled: yup.boolean(),
  email: yup.string().email('Email must be valid'),
  mobilePhoneNumber: yup
    .string()
    .test('phone-number-has-10-digits', 'You must enter a 10-digit phone number', str =>
      str ? str?.replace(/\D/g, '').length === 10 : true,
    ),
});
